<template>
  <div 
    v-bind:aria-labelledby="tabId"
    v-bind:hidden="!activeTab"
    v-bind:id="panelId"
    class="c-tabs__tabpanel"
    role="tabpanel"
    tabindex="0">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "SearchTab",
  props: ["name", "panelSuffix", "tabSuffix", "isActive", "title"],
  data() {
    return {
      activeTab: this.isActive
    };
  },
  computed: {
    panelId() {
      return this.name + this.panelSuffix;
    },
    selected() {
      return this.activeTab.toString();
    },
    tabId() {
      return this.name + this.tabSuffix;
    },
    tabIndex() {
      return (this.activeTab) ? 0 : -1;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/components/searches/results/SearchTab.vue